import { seedAliasParts } from '~/lib/seed-merge';

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return;
  const parts = seedAliasParts(to.fullPath);
  if (!parts) return;
  const result = await $fetch<{ targetId: number | null }>('/api/seeds/alias', { query: { id: parts.id } });
  if (result.targetId) return navigateTo(`/catalog/product-${result.targetId}${parts.suffix}`, { redirectCode: 301, replace: true });
});


